import React, { useState, useEffect } from 'react'
import IndividualEstimate from './individualEstimate'
import { applicationRoles } from 'constants/actionTypes'
import { useHistory } from 'react-router-dom'
import { Alert } from 'react-bootstrap'
import { fireInteractionCustomEvent, toLowerCase, formatCurrency } from 'helpers'
import ContactUsDialog from '../../dialog/contactUsDialog'
import { useSelector } from 'react-redux'
import * as E from './estimateDetailElements'
import SpartaCustomerCount from '../estimate-compare/spartaCustomerCount'
import { Icon } from 'icons'
import { SubMenuBar } from '@mmsg/louie'
import zenscroll from 'zenscroll'

const EstimateDetails = ({
  isConsultant,
  bannerData,
  isValid,
  vehicle,
  carData,
  summaryData,
  runningData,
  financialInclusionData,
  endOfLeaseData,
  novatedLeaseData,
  releaseData,
  isEstimateValid,
}) => {
  const history = useHistory()
  const applicationRole = isConsultant
    ? applicationRoles.CONSULTANT
    : applicationRoles.CUSTOMER

  const pdfViewClick = () => {
    history.push(history.location.pathname + '/pdfview')

    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'view pdf',
          label: 'view pdf',
        },
      },
    })
  }

  const afterMarketAccessories = useSelector(
    (state) => state.individualEstimate.afterMarketAccessories
  )

  const isAtProposal = useSelector(
    (state) =>
      state.proposal &&
      state.proposal.proposal &&
      state.proposal.proposal.isValid
  )

  const isAtProposalButNotThisEstimate = useSelector(
    (state) =>
      state.proposal &&
      state.proposal.proposal &&
      state.proposal.proposal.isValid &&
      state.proposal.proposal.quoteId !=
        state.individualEstimate.selectedEstimateId
  )

  let isEvRebate = carData.isEvRebate &&
    toLowerCase(carData.fuelType) === 'electric' &&
    toLowerCase(carData.vehicleType) === "new"

  let isSpartaVehicle =
    carData.vehicleId &&
    carData.shadowPR &&
    carData.spartaDetail &&
    carData.spartaDetail.offerActive

  let spartaDetail = carData.spartaDetail

  if (spartaDetail && !spartaDetail.offerActive) {
    isValid = false
  }

  let line1
  let line2
  let icon
  if (isSpartaVehicle) {
    line1 =
      'This car is part of a limited stock order and may have been offered to other customers. It could become unavailable if not secured.'

    if (spartaDetail && spartaDetail.numberOfCustomerOffered > 5) {
      line2 = spartaDetail.numberOfCustomerOffered + ' others interested now'
      icon = <Icon iconType="Flame" />
    }
  } else if (isEvRebate) {

    line1 = `This electric vehicle may be eligible for a ${formatCurrency(carData.evRebateValue)} EV Bonus!`
    line2 =
      `For more information, chat to your consultant. The ${formatCurrency(carData.evRebateValue)} EV Bonus is not included in any calculations below. ` +
      ('<a href=' + carData.evRebateTnCLink +
        ' target="_blank" rel="noopener noreferrer" class="link">' +
        'Terms &amp; Conditions Apply' +
        '</a>')

        icon = <Icon iconType="EVBolt" />
  }

  const scrollZen = (about) => {
    var myDiv = document.getElementById(about)
    const rect = myDiv.getBoundingClientRect()

    const y = rect.top + window.scrollY - 50 //extra space of submenubar removed

    zenscroll.toY(y, 100)
  }
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const onScroll = () => setOffset(zenscroll.getY())
    // clean up code
    window.removeEventListener('scroll', onScroll)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const carDetailsY =
    document.getElementById('carDetails') &&
    zenscroll.getTopOf(document.getElementById('carDetails'))

  const summaryY =
    document.getElementById('summary') &&
    zenscroll.getTopOf(document.getElementById('summary'))

  const budgetY =
    document.getElementById('budget') &&
    zenscroll.getTopOf(document.getElementById('budget'))

  const addOnY =
    document.getElementById('addOn') &&
    zenscroll.getTopOf(document.getElementById('addOn'))

  const eolY =
    document.getElementById('eol') &&
    zenscroll.getTopOf(document.getElementById('eol'))

  const termsandconditionsY =
    document.getElementById('termsandconditions') &&
    zenscroll.getTopOf(document.getElementById('termsandconditions'))

  const submenuBarSizeConstant = 51
  return (
    <>
      <div id="page" className="estimate-details">
        <IndividualEstimate className="vehicle-estimate-page">
          <E.SubMenuContainer>
            <SubMenuBar
              background="#000"
              color="#fff"
              buttons={[
                {
                  name: 'Car Details',
                  onClick: () => {
                    scrollZen('carDetails')
                  },
                  active: offset + submenuBarSizeConstant < summaryY,
                },
                {
                  name: 'Lease Summary',
                  onClick: () => {
                    scrollZen('summary')
                  },
                  active:
                    offset + submenuBarSizeConstant >= summaryY &&
                    offset + submenuBarSizeConstant < budgetY,
                },
                {
                  name: 'Your Budget',
                  onClick: () => {
                    scrollZen('budget')
                  },
                  active:
                    offset + submenuBarSizeConstant >= budgetY &&
                    offset + submenuBarSizeConstant < addOnY,
                },
                {
                  name: 'Add-On Insurance',
                  onClick: () => {
                    scrollZen('addOn')
                  },
                  active:
                    offset + submenuBarSizeConstant >= addOnY &&
                    offset + submenuBarSizeConstant < eolY,
                },
                {
                  name: 'End-Of-Lease',
                  onClick: () => {
                    scrollZen('eol')
                  },
                  active:
                    offset + submenuBarSizeConstant >= eolY &&
                    offset + submenuBarSizeConstant < termsandconditionsY,
                },
                {
                  name: 'Important Info',
                  onClick: () => {
                    scrollZen('termsandconditions')
                  },
                  active: offset + 51 >= termsandconditionsY,
                },
              ]}
              viewPdf={{ name: 'View PDF', onClick: pdfViewClick }}
            />
          </E.SubMenuContainer>
          <IndividualEstimate.Banner
            data={bannerData}
            applicationRole={applicationRole}
            // pdfViewClick={pdfViewClick}
          />
          {!isValid && (
            <Alert
              variant="danger"
              className="section container text-left mt-4 w-100"
            >
              <E.styledAlertIcon />
              <div className="text-small ml-3 mt-3">
                <p>
                  Cannot proceed with an inactive estimate. Please{' '}
                  {applicationRole &&
                  applicationRole !== applicationRoles.CONSULTANT ? (
                    <b>
                      <ContactUsDialog
                        className="link"
                        theme="link"
                        launchText="contact your consultant"
                        inlineText
                      />
                    </b>
                  ) : (
                    'Contact your consultant'
                  )}{' '}
                  to discuss.
                </p>
              </div>
            </Alert>
          )}

          {isValid && (isSpartaVehicle || isEvRebate) && 
            <SpartaCustomerCount
              line1={line1}
              line2={line2}
              icon={icon}
              iconTopLine={isEvRebate}
              extended={line2 === null}
              spacingValue={line2 ? 3 : 2}
            />
          }

          {releaseData.isRelease && (
            <IndividualEstimate.Release {...releaseData} />
          )}
          <div id="carDetails" />
          <IndividualEstimate.Car
            data={carData}
            applicationRole={applicationRole}
            afterMarketAccessories={afterMarketAccessories}
            novatedLeaseData={novatedLeaseData}
            pdfViewClick={pdfViewClick}
          />

          <div id="summary" />
          <IndividualEstimate.Summary
            data={summaryData}
            applicationRole={applicationRole}
          />

          <div id="budget" />
          <IndividualEstimate.Running
            data={runningData}
            applicationRole={applicationRole}
          />

          <div id="addOn" />
          <IndividualEstimate.FinancialInclusion
            data={financialInclusionData}
            applicationRole={applicationRole}
            isGov={false}
          />

          <div id="eol" />
          <IndividualEstimate.EndOfLease
            data={endOfLeaseData}
            applicationRole={applicationRole}
            novatedLeaseData={novatedLeaseData}
            pdfViewClick={pdfViewClick}
            isGov={false}
            isValid={isValid}
          />
        </IndividualEstimate>
      </div>
      <div id="myMm" style={{ height: '1mm' }} />
    </>
  )
}

export default EstimateDetails
